import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasFirstDistrictMemberCenterAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && user.permissions.includes('FIRSTDISTRICT_MEMBER_CENTER');
    }
}
